import React from 'react';
import iconInfo from 'static/img/help.svg';

export default () => <img style={{width: '16px', height: '16px'}} src={iconInfo} alt="" />;
